/**
 * Prefill UK shipping fields:
 * 1) last supplies order
 * 2) profile default / first stored address
 * 3) computed shippingAddress (API) or restaurant address
 * Never includes card details.
 */
export function getPrefillShippingAddress(user, suppliesOrders = []) {
  const lastOrder = Array.isArray(suppliesOrders) ? suppliesOrders[0] : null;
  const fromOrder = lastOrder?.shippingAddress;
  if (fromOrder?.street || fromOrder?.postalCode) {
    return {
      shippingStreet: fromOrder.street || "",
      shippingCity: fromOrder.city || "",
      shippingState: fromOrder.state || "",
      shippingPostalCode: fromOrder.postalCode || "",
      fromPreviousOrder: true,
      fromStoredAddress: false,
    };
  }

  const addresses = Array.isArray(user?.addresses) ? user.addresses : [];
  const defaultAddr =
    addresses.find((a) => a.id === user?.defaultAddressId) ||
    addresses.find((a) => a.isDefault) ||
    addresses[0] ||
    null;

  const a = defaultAddr || user?.shippingAddress || user?.address || {};

  const street = a.street || a.line1 || "";
  const city = a.city || "";
  const state = a.state || a.county || "";
  const postalCode = a.postalCode || a.postcode || a.pincode || "";

  return {
    shippingStreet: street,
    shippingCity: city,
    shippingState: state,
    shippingPostalCode: postalCode,
    fromPreviousOrder: false,
    fromStoredAddress: !!(street || postalCode),
  };
}
